import { render, staticRenderFns } from "./PoaQuestion.vue?vue&type=template&id=2caf4a4a&scoped=true&"
import script from "./PoaQuestion.vue?vue&type=script&lang=js&"
export * from "./PoaQuestion.vue?vue&type=script&lang=js&"
import style0 from "./PoaQuestion.vue?vue&type=style&index=0&id=2caf4a4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caf4a4a",
  null
  
)

export default component.exports